import React from "react"

import ConfirmationInterstitial from "@/components/public/confirmation_interstitial"
import { PublicReservationStatus } from "@/graphql/graphql"

import CancellationModals from "./cancellation_modals"
import { useCancellationFlow } from "./use_cancellation_flow"
import { useConfirmationFlow } from "./use_confirmation_flow"

type Props = {
  cancelContactHref?: string
  cancelLoading: boolean
  cancelModalState: ReturnType<typeof useCancellationFlow>["cancelModalState"]
  closeCancelModal: () => void
  handleConfirmCancellation: () => void
  interstitialMode: ReturnType<typeof useConfirmationFlow>["interstitialMode"]
  reservationStatus: PublicReservationStatus
  setInterstitialMode: ReturnType<typeof useConfirmationFlow>["setInterstitialMode"]
  venueSlug: string
}

const ReservationPageOverlays: React.FC<Props> = ({
  cancelContactHref,
  cancelLoading,
  cancelModalState,
  closeCancelModal,
  handleConfirmCancellation,
  interstitialMode,
  reservationStatus,
  setInterstitialMode,
  venueSlug,
}) => {
  return (
    <>
      {interstitialMode ? (
        <ConfirmationInterstitial
          mode={interstitialMode}
          onDismiss={() => setInterstitialMode("hide")}
          onExited={() => setInterstitialMode(null)}
        />
      ) : null}

      <CancellationModals
        cancelContactHref={cancelContactHref}
        cancelLoading={cancelLoading}
        cancelModalState={cancelModalState}
        onClose={closeCancelModal}
        onConfirm={handleConfirmCancellation}
        reservationStatus={reservationStatus}
        venueSlug={venueSlug}
      />
    </>
  )
}

export default ReservationPageOverlays
